export default {
    routerName: 'ユーザー詳細',
    user: {
        icon: 'アイコン',
        deptName: '部門名',
        name: '氏名',
        loginName: 'アカウント',
        email: 'メール',
        password: 'パスワード',
        mobile: '電話番号',
        type: 'タイプ',
        systemUser: 'システムユーザー',
        normalUser: '普通ユーザー',
        members: '会員ユーザー',
        sex: '性別',
        status: '状態',
        remark: '備考',
        male: '男性',
        female: '女性',
        open: '有効',
        close: '無効',
        postName: '職位',
        roleName: 'ロール',
        loginIp: 'ログインIP',
        loginTime: 'ログイン日付',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
    },
    info: {
        accountNotChange: 'ユーザー登録後でアカウントが変更できません。',
    },
    role: {
        roleDistribute: '配分',
    },
};
